import { EEmployeeRole, EmployeeProperties } from "./employee.type";

export enum EEmployeeRoleApprovalStatus {
	OPEN = "OPEN",
	WAITING_APPROVAL = "WAITING_APPROVAL",
	APPROVED = "APPROVED",
	REJECTED = "REJECTED",
}
export enum EEmployeeRoleStatus {
	OPEN = "OPEN",
	PUBLISH = "PUBLISH",
	UNPUBLISH = "UNPUBLISH",
	INACTIVE = "INACTIVE",
}

export interface EmployeeRoleProperties {
	employeeRoleId: string;
	employeeId: string;
	role: EEmployeeRole;
	approvalStatus: EEmployeeRoleApprovalStatus;
	status: EEmployeeRoleStatus;
	actionByUserId?: string;
	actionByUserMeta?: any;
	actionRemark?: string;
	updatedAt: Date;
	createdAt: Date;

	employee?: Omit<EmployeeProperties, "employeeRole">;
}
